import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import { useRef } from "react";
import { motion, useAnimationFrame } from "framer-motion";
import clienteCos from "assets/images/clients/cliente_cos2.png";
import clienteGd from "assets/images/clients/cliente_gd2.png";
import clienteSystem from "assets/images/clients/clientes_system2.png";
import clientePromaquina from "assets/images/clients/promaquina.png";
import casaboa from "assets/images/partners/casaboa2.png";
import haas from "assets/images/partners/haas2.png";
import romi from "assets/images/partners/romi2.png";
import bgImage from "assets/images/banner-parceiros.png";
import toyo from "assets/images/partners/toyo.png";
import taruma from "assets/images/partners/taruma.png";
import acossarti from "assets/images/partners/acossarti.png";
import centertools from "assets/images/partners/centertools.png"

import MKTypography from 'components/MKTypography';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const logos = [
  { src: clienteCos, alt: "COS Brasil - Cliente Ramlis Machine" },
  { src: clienteGd, alt: "G.D do Brasil - Cliente Ramlis Machine" },
  { src: clienteSystem, alt: "System IPT - Cliente Ramlis Machine" },
  { src: clientePromaquina, alt: "Promaquinas - Cliente Ramlis Machine" },
  { src: casaboa, alt: "Casa da Boia - Parceira Ramlis Machine" },
  { src: haas, alt: "Haas Automação - Parceira Ramlis Machine" },
  { src: romi, alt: "Romi - Parceira Ramlis Machine" },
  { src: toyo, alt: "Toyo Matic - Parceira Ramlis Machine" },
  { src: taruma, alt: "Aços Tarumã - Parceira Ramlis Machine" },
  { src: acossarti, alt: "Aços Sarti - Parceira Ramlis Machine"},
  { src: centertools, alt: "Center Tools - Parceira Ramlis Machine"}
];

function InfiniteLogos() {
  const ref = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  useAnimationFrame((t) => {
    if (ref.current) {
      const speed = isMobile ? 0.08 : 0.12;
      ref.current.scrollLeft = (t * speed) % (ref.current.scrollWidth / 2);
    }
  });

  const getLogoStyles = () => {
    if (isMobile) {
      return {
        minWidth: 100,
        height: 50,
        margin: "0 12px",
        padding: "8px 12px",
      };
    } else if (isTablet) {
      return {
        minWidth: 120,
        height: 60,
        margin: "0 16px",
        padding: "10px 16px",
      };
    } else {
      return {
        minWidth: 150,
        height: 70,
        margin: "0 24px",
        padding: "12px 20px",
      };
    }
  };

  const getImageStyles = () => {
    if (isMobile) {
      return {
        height: 40,
        maxWidth: 90,
      };
    } else if (isTablet) {
      return {
        height: 50,
        maxWidth: 110,
      };
    } else {
      return {
        height: 60,
        maxWidth: 140,
      };
    }
  };

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        overflow: "hidden",
        margin: "0 auto",
        userSelect: "none",
        padding: isMobile ? "12px 0" : "20px 0",
      }}
    >
      <div style={{ display: "flex", flexWrap: "nowrap" }}>
        {[...logos, ...logos].map((logo, i) => (
          <motion.div
            key={i}
            style={{
              background: "rgba(255,255,255,0.92)",
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 24px rgba(0,0,0,0.08)",
              border: "1px solid #eee",
              ...getLogoStyles(),
            }}
            whileHover={{
              scale: isMobile ? 1.05 : 1.07,
              boxShadow: "0 4px 32px rgba(20,90,30,0.08)",
            }}
          >
            <img
              src={logo.src}
              alt={logo.alt}
              style={{
                objectFit: "contain",
                ...getImageStyles(),
              }}
              loading="lazy"
              draggable={false}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default function Parceiros() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ParallaxProvider>
      <section
        aria-labelledby="clientes-parceiros"
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          minHeight: isMobile ? "60vh" : isTablet ? "70vh" : "80vh", // Altura responsiva
          paddingTop: isMobile ? "30px" : "60px",
          paddingBottom: isMobile ? "30px" : "60px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // Centraliza melhor o conteúdo
          alignItems: "center",
        }}
      >

        {/* Background com parallax - CORRIGIDO */}
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          height: "100%",
          width: "100%"
        }}>
          <Parallax speed={isMobile ? -15 : -20}>
            <div style={{
              width: "100%",
              height: "100%",
              position: "relative"
            }}>
              <img
                src={bgImage}
                alt="Parceiros e clientes da Ramlis Machine no Brasil"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: isMobile ? "300px" : isTablet ? "300px" : "100px",
                  objectFit: "cover",
                  objectPosition: isMobile ? "center 30%" : "center", // Ajusta o foco da imagem no mobile
                  filter: "brightness(0.6)",
                }}
                loading="lazy"
              />
              {/* Overlay para melhorar legibilidade */}
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.3) 100%)"
              }} />
            </div>
          </Parallax>
        </div>

        {/* Conteúdo */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            padding: isMobile ? "20px 16px" : "40px 20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
            flex: 1
          }}
        >
          {/* TÍTULO */}
          <MKTypography
            component="h2"
            id="clientes-parceiros"
            sx={{
              fontFamily: "'Martian Mono', sans-serif",
              fontSize: isMobile ? "1.4rem" : isTablet ? "2rem" : "3rem",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: isMobile ? "1px" : "3px",
              color: "#fff",
              mb: isMobile ? 1 : 2,
              textShadow: "0 2px 8px rgba(0,0,0,0.7)",
              textAlign: "center",
              display: "block",
              px: 2,
              lineHeight: 1.2
            }}
          >
            Clientes e Parceiros
          </MKTypography>

          {/* PARÁGRAFO */}
          <p
            style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: isMobile ? "0.9rem" : isTablet ? "1.1rem" : "1.35rem",
              lineHeight: 1.5,
              fontWeight: 300,
              opacity: 0.95,
              maxWidth: "900px",
              width: "100%",
              color: "#fff",
              marginBottom: isMobile ? "20px" : "32px",
              marginTop: isMobile ? "8px" : "12px",
              padding: isMobile ? "0 12px" : "0 16px",
              textAlign: "center",
              display: "block",
              wordBreak: "break-word",
              whiteSpace: "normal",
              textShadow: "0 1px 4px rgba(0,0,0,0.6)"
            }}
          >
            Empresas que confiam na Ramlis Machine para soluções de usinagem de precisão,
            moldes e dispositivos.
          </p>

          {/* CARROSSEL */}
          <Parallax speed={isMobile ? 2 : 4}>
            <div style={{ 
              width: "100%", 
              maxWidth: 1100,
              padding: isMobile ? "0 8px" : "0 16px"
            }}>
              <InfiniteLogos />
            </div>
          </Parallax>

        </div>
      </section>
    </ParallaxProvider>
  );
}